import(/* webpackMode: "eager" */ "/app/apps/memex-style/components/footer/copyright/CopyRight.jsx");
import(/* webpackMode: "eager" */ "/app/apps/memex-style/components/footer/Footer.jsx");
import(/* webpackMode: "eager" */ "/app/apps/memex-style/components/header/HeaderDefault.jsx");
import(/* webpackMode: "eager" */ "/app/apps/memex-style/components/hero/HeroServiceDetailsHeader.jsx")